import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Card from '../../components/Card';

function ProjectPage() {
  const [project, setProject] = useState(null); 
  const { prjid } = useParams(); 
  const [relatedObjects, setRelatedObjects] = useState([]); 
  const uniqueObjectIds = new Set(); 
  const [loadingRelatedObjects, setLoadingRelatedObjects] = useState(true); 

  const fetchItem = async () => {
    try {
      const response = await fetch(`/api/prj/${prjid}`);
      const jsonData = await response.json();
      setProject(jsonData[0]); 


      const objectIds = jsonData[0].obj_id;
      for (const id of objectIds) {
        console.log(`Fetching related object with ID: ${id}`); 
        await fetchRelatedObject(id); 
      }
    } catch (err) {
      console.error(err.message);
    }
  };


const fetchRelatedObject = async (id) => {
  try {
    const response = await fetch(`/api/item/${id}`);
    const jsonData = await response.json();

    const newObjects = Array.isArray(jsonData) ? jsonData : [jsonData];

    newObjects.forEach(newObj => {
      if (!uniqueObjectIds.has(newObj.obj_id)) {
        uniqueObjectIds.add(newObj.obj_id); 
        setRelatedObjects(prevObjects => [...prevObjects, newObj]); 
      }
    });

    setLoadingRelatedObjects(false);

    console.log("Updated relatedObjects:", relatedObjects);
  } catch (err) {
    console.error("Error fetching related objects:", err);
    setLoadingRelatedObjects(false); 
  }
};

  useEffect(() => {
    fetchItem();
  }, [prjid]);

  if (!project) {
    return <p>Loading...</p>; 
  }
  
  return (
    <Fragment>
<div className="detailpage">
  <div className="dtpg_img">
<img 
    src={`/api/uploads/${project.prj_img}`}
    alt={project.prj_img}
  />
  </div>
<h1 id="prj_title">Project: {project.prj_name}</h1>
<div 
    className="project-description" 
    dangerouslySetInnerHTML={{ __html: project.prj_desc }} 
  />

<h4 id="rel_title">Related Objects</h4>
      <div className="related-objects">
      <div className="container">
      <div className="wrapper">
      <div className="csrow">
              {relatedObjects.map(object => {
const media = object.media ? 'thumb_' + object.media.split(',')[0] : '';   
                
                return (
                  <Card
                    key={object.obj_id}
                    id={object.obj_id}
                    ref_id={object.ref_id}
                    title={object.title}
                    media={media}  
                    media_type={object.med_name}
                    project={object.prj_name}
                    record_date={object.record_date ? new Date(object.record_date).toLocaleDateString() : 'No date available'}
                  />
                );
              })}
            </div>      
        </div>
        </div>
        </div>
        </div>
    </Fragment>
  );
  
}

export default ProjectPage;
